import type { AalView } from "../aalV2";
import { useAalListQuery } from "../aalV2";

export type AllAALTableFilters = {
  view: AalView;
  start_date: string;
  end_date: string;
  page?: number;
  size?: number;
  sort?: string;
  event_category?: string;
  action_type?: string;
  agent_id?: string;
  agent_role_id?: string;
  source_ip?: string;
  target_user_id?: string;
  username?: string;
};

export type AllAALTableItem = {
  event_id?: string | null;
  event_sort_key?: string | null;
  created_at: string;
  event_category: string;
  action_type: string;
  money_type?: string | null;
  amount?: string | number | null;
  operation?: string | null;
  reason?: string | null;
  agent_id?: string | null;
  agent_email?: string | null;
  agent_role_id?: string | null;
  agent_role_name?: string | null;
  source_ip?: string | null;
  target_user_id?: string | null;
  target_username?: string | null;
};

export type AllAALApvTableItem = {
  agent_id: string;
  agent_email: string;
  agent_role_id: string | null;
  agent_role_name: string | null;
  rebet_cash_delta: number;
  casino_cash_delta: number;
  p_cash_delta: number;
  rebet_cash_pct_change: number;
  casino_cash_pct_change: number;
  p_cash_pct_change: number;
  users_suspended_delta: number;
  users_unsuspended_delta: number;
  users_suspended_pct_change: number;
  users_unsuspended_pct_change: number;
  bet_turnover: number;
  bet_pnl: number;
  bets_settled_count: number;
  bet_amount_realized: number;
  bet_turnover_pct_change: number;
  bet_pnl_pct_change: number;
  bets_settled_count_pct_change: number;
  bet_amount_realized_pct_change: number;
  promos_given: number;
  promos_removed: number;
  promos_amount: number;
  promos_given_pct_change: number;
  promos_removed_pct_change: number;
  promos_amount_pct_change: number;
  free_pick_amount_delta?: number;
  free_picks_amount_pct_change?: number;
  free_picks_amount_realized?: number;
  free_picks_amount_realized_pct_change?: number;
  free_picks_given?: number;
  free_picks_given_pct_change?: number;
  profit_boosts_amount_realized?: number;
  profit_boosts_amount_realized_pct_change?: number;
  profit_boosts_given?: number;
  profit_boosts_given_pct_change?: number;
  free_spins_amount_realized?: number;
  free_spins_amount_realized_pct_change?: number;
  free_spins_given?: number;
  free_spins_given_pct_change?: number;
  total_withdrawal_amount_reviewed?: number;
  total_withdrawal_amount_reviewed_pct_change?: number;
  withdrawals_reviewed_count?: number;
  withdrawals_reviewed_count_pct_change?: number;
  withdrawals_approved_count?: number;
  withdrawals_approved_count_pct_change?: number;
  withdrawals_declined_count?: number;
  withdrawals_declined_count_pct_change?: number;
  promos_amount_realized?: number;
  promos_amount_realized_pct_change?: number;
  avg_request_to_decision_seconds?: number | null;
  avg_review_start_to_decision_seconds?: number | null;
};

export const useGetAALAllTable = (filters: AllAALTableFilters) => {
  const {
    view,
    start_date,
    end_date,
    page,
    size,
    sort,
    event_category,
    action_type,
    agent_id,
    agent_role_id,
    source_ip,
    target_user_id,
    username,
  } = filters;

  return useAalListQuery<AllAALTableItem | AllAALApvTableItem>("all", view, {
    start_date,
    end_date,
    page,
    size,
    sort,
    filters:
      view === "events"
        ? {
            event_category,
            action_type,
            agent_id,
            agent_role_id,
            source_ip,
            target_user_id,
            username,
          }
        : {
            agent_id,
            agent_role_id,
            target_user_id,
            username,
          },
  });
};
